'use client';
import dynamic from 'next/dynamic';

const dynamicIconImport = (iconName) => {
  return dynamic(() => import(`@/app/_components/ui/icons/${iconName}.svg`));
};

export default dynamicIconImport;
